import { parrotApi } from '@libs/openapi';
import { poolParrotModel } from '@models/pool.parrot.model';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDebounce } from 'react-use';
import { OpenapiClientParrot } from 'src/openapi/parrot';
import { Decimal } from 'parrot-sui-sdk';

export const useParrotPoolPriceOhlc = (coinA: string, coinB: string) => {
  const [data, setData] = useState<OpenapiClientParrot.GetClmmPoolsByPoolIdOhlcResponse>();
  const [isEmpty, setIsEmpty] = useState(false);
  const [poolId, setPoolId] = useState<string>();

  useDebounce(
    async () => {
      if (!coinA || !coinB) {
        setIsEmpty(true);
        return;
      }
      setIsEmpty(false);
      setPoolId(undefined);
      const pools = await poolParrotModel.getHttpPools({
        limit: 10,
        page: 1,
        tokens: [coinA, coinB],
      });

      let pool = pools?.result[0];
      if (pool && pools && pools.result.length > 0) {
        pools.result.forEach((item) => {
          if (new Decimal(item.liquidity).gt(pool!.liquidity)) {
            pool = item;
          }
        });
      }
      setPoolId(pool?.pool_id);
      setIsEmpty(!pool?.pool_id);
    },
    10,
    [coinA, coinB],
  );

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    if (poolId) {
      const loop = async (again: boolean = false) => {
        if (again) {
          setData(undefined);
        }
        try {
          const result = await parrotApi.get('/clmm/pools/{pool_id}/ohlc', {
            query: {
              start: dayjs.utc().format(),
              end: dayjs.utc().subtract(10, 'year').format(),
              step: 'year',
            },
            params: {
              pool_id: poolId,
            },
          });
          setData(result);
          timer = setTimeout(() => {
            loop(false);
          }, 30_000); // 30 seconds
        } catch (err) {
          setData([]);
        }
      };
      loop(true);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [poolId]);

  return {
    isEmpty,
    poolId,
    data,
  };
};
